import {timeStampToTime} from 'app/utils';
import I18n from 'app/i18n';

export const getAuthor = function(author: string, date: number, article_type: string): string {
    const authorName = author || 'EGB';
    return article_type === 'news' || article_type === 'blog' || article_type === 'promotion'
        ? `${timeStampToTime(date)} ${I18n.t('egb_team_show', {name: authorName})}`
        : timeStampToTime(date);
};
